import {
	backButton,
	viewport,
	themeParams,
	miniApp,
	initData,
	setDebug,
	init as initSDK,
	swipeBehavior,
} from '@tma.js/sdk-vue';

/**
 * Initializes the application and configures its dependencies.
 */
export function initTg(debug: any = false) {
	// Enable @tma.js/sdk debug mode.
	setDebug(debug);

	// Initialize special event handlers for Telegram Desktop, Android, iOS, etc.
	initSDK();

	// Add Eruda if needed.
	if (debug) {
		import('eruda')
			.then((lib) => lib.default.init())
			.catch(console.error);
	}

	// Mount components only if the current client supports them.
	// Each .mount/.bindCssVars is a WithChecks wrapper — calling it on
	// unsupported clients produces "Method not found" Sentry errors.
	if (backButton.mount.isAvailable()) {
		backButton.mount();
	}
	if (miniApp.mount.isAvailable()) {
		miniApp.mount();
	}
	if (themeParams.mount.isAvailable()) {
		themeParams.mount();
	}

	// initData.restore() is a plain function (not WithChecks-wrapped) and safe to call.
	initData.restore();

	if (viewport.mount.isAvailable()) {
		void viewport
			.mount()
			.catch(e => {
				console.error('Something went wrong mounting the viewport', e);
			})
			.then(() => {
				if (viewport.bindCssVars.isAvailable()) {
					viewport.bindCssVars();
				}
			});
	}

	if (miniApp.bindCssVars.isAvailable()) {
		miniApp.bindCssVars();
	}
	if (themeParams.bindCssVars.isAvailable()) {
		themeParams.bindCssVars();
	}

	if (viewport.expand.isAvailable()) {
		viewport.expand();
	}

	if (swipeBehavior.mount.isAvailable()) {
		swipeBehavior.mount();
		if (swipeBehavior.isMounted() && swipeBehavior.disableVertical.isAvailable()) {
			swipeBehavior.disableVertical();
		}
	}

	if (debug) {
		const width = 422;
		document.documentElement.style.setProperty('--tg-viewport-width', `${width}px`);
	}
}
